import MarkImage from "./images/MC_SheIsPriceless_Mark_Elliott_2_500x750.jpg";


const Mark = ({breakPoints}) => {
  return (
    <div className={`flex justify-center items-center py-10 ${breakPoints}`}>
      {/* Updated this div for responsive grid layout */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-9">
        {/* First column now taking 1/3 of the space on medium devices and up */}
        <div className="md:col-span-2 text-white flex flex-col justify-center items-center">
          <img src={MarkImage} alt="Mark Elliott" className="w-1/2 md:w-full" />
        </div>
        {/* Second column now taking 2/3 of the space on medium devices and up */}
        <div className="md:col-span-3 text-white flex flex-col justify-between">
          <div className="text-lg md:text-sm text-left font-markWebPro">
            <p className="pb-2">
              In Africa, where women constitute more than half of the population, Mastercard is dedicated to carving out exceptional opportunities in industries where women have traditionally been underrepresented. Our vision is clear: to become the employer, brand, and partner of choice for women, creating a landscape where their talents and perspectives are not only welcomed but are essential for innovation and growth.
            </p>
            <p className="pb-2">
            She is Priceless underscores Mastercard's dedication to fostering a workplace where women are not just participants but pivotal leaders. While She is Priceless recognizes some of Mastercard's exceptional women in leadership, it is not only a corporate showcase of women in leadership. Instead, it represents our earnest commitment to promote true diversity and inclusivity across our organization and into the communities where we are represented. This transcends the conventional portrayal of women in business, celebrating the unique qualities women bring to the table - their insight, creativity, and ability to inspire positive change. 
            </p>
            <p className="pb-5">
            We see the concept of She is Priceless as integral to the balance and progress of our company in a rapidly digitizing world. She is Priceless is not just a symbol
            but a driving force, a catalyst for a future that is more inclusive, equitable, and prosperous for all. At Mastercard, we recognize that
            She is Priceless because she makes business better and communities stronger. 
            </p>
            <div className="font-markWebPro text-xl pb-1 text-mcHead">
            Mark Elliott
            </div>
            <div className="font-markScForMCNarrowM">
             DIVISION PRESIDENT, SUB-SAHARAN AFRICA
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mark;
